/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbaording_Permission_List_Break_EndInputs */

const en_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Break time is over`)
};

const ar_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتهى وقت الاستراحة`)
};

const de_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Pause ist vorbei`)
};

const es_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El tiempo de descanso ha terminado`)
};

const fr_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pause est terminée`)
};

const it_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pausa è finita`)
};

const ja_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休憩時間が終わったとき`)
};

const ko_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`쉬는 시간이 끝났을 때`)
};

const pt_br_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fim do intervalo`)
};

const ru_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перерыв окончен`)
};

const th_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาพักสิ้นสุดแล้ว`)
};

const tr_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mola bitti`)
};

const zh_cn_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休息时间结束`)
};

const zh_tw_onbaording_permission_list_break_end = /** @type {(inputs: Onbaording_Permission_List_Break_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`休息時間結束`)
};

/**
* | output |
* | --- |
* | "Break time is over" |
*
* @param {Onbaording_Permission_List_Break_EndInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const onbaording_permission_list_break_end = /** @type {((inputs?: Onbaording_Permission_List_Break_EndInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbaording_Permission_List_Break_EndInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbaording_permission_list_break_end(inputs)
	if (locale === "ar") return ar_onbaording_permission_list_break_end(inputs)
	if (locale === "de") return de_onbaording_permission_list_break_end(inputs)
	if (locale === "es") return es_onbaording_permission_list_break_end(inputs)
	if (locale === "fr") return fr_onbaording_permission_list_break_end(inputs)
	if (locale === "it") return it_onbaording_permission_list_break_end(inputs)
	if (locale === "ja") return ja_onbaording_permission_list_break_end(inputs)
	if (locale === "ko") return ko_onbaording_permission_list_break_end(inputs)
	if (locale === "pt_br") return pt_br_onbaording_permission_list_break_end(inputs)
	if (locale === "ru") return ru_onbaording_permission_list_break_end(inputs)
	if (locale === "th") return th_onbaording_permission_list_break_end(inputs)
	if (locale === "tr") return tr_onbaording_permission_list_break_end(inputs)
	if (locale === "zh_cn") return zh_cn_onbaording_permission_list_break_end(inputs)
	return zh_tw_onbaording_permission_list_break_end(inputs)
});